<div class="switch-theme">
    <span *ngFor="let theme of themes" (click)="onSwitchTheme(theme)">{{ theme.label }}</span>
</div>
